import {Injectable} from '@angular/core';

import {ScoreState} from '@app/core/states/score/score.state';

@Injectable({providedIn: 'root'})
export class ScoreFacade {
  /**
   * Holds the value of selected score
   * @type {Observable<ScoreModel>}
   */
  public score$   = this._state.score$;

  /**
   * Holds the id of selected score
   * @type {Observable<ScoreType>}
   */
  public scoreId$ = this._state.scoreId$;

  /**
   * Holds the scores list
   * @type {Observable<ScoreModel[]>}
   */
  public scores$ = this._state.scores$;

  /**
   * Will be used to update the selection
   * @param {ScoreType} componentId
   */
  public updateScoreId = this._state.updateScoreId.bind(this._state);

  public constructor(private readonly _state: ScoreState) {}
}
